import '../stylesheets/ContentContainer.less';
import { Placeholder, Container, Grid, Segment, Button, Card, Item, Image, Icon, Embed, Header } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'react';


const ContentContainer = ({ inViewpoint, content }) => {
  
  // console.log(inViewpoint)
  const contentRefs = JSON.parse(document.getElementById('showroomContentRefs').textContent)
  const currentContentSrc = (contentRefs[inViewpoint] != null) 
    ? contentRefs[inViewpoint].find(e => e.content_name === content)?.url || 'https://www.raute.com/' 
    : 'https://www.raute.com/'

  return (
        (currentContentSrc != null) ?
          <iframe 
            src={currentContentSrc} 
            className="content-iframe catch-pointer-events" 
            frameBorder="0" width="100%" height="100%"
            title="content-iframe">
          </iframe>
          : <></>
  )
}

ContentContainer.propTypes = {
  inViewpoint: PropTypes.string,
  content: PropTypes.string
}

export default ContentContainer;
